import CONFIG from '@/config/config.ts';
import { useMobileMediaQuery } from '@/utils/useMobileMediaQuery.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import VideoFull from '@/views/process/components/quizInialized/intro/segments/VideoFull.tsx';
import { QuestionSegmentProps } from '@/views/process/components/quizInialized/questions/QuestionSegment.model.ts';
import QuestionWrapper from '@/views/process/components/quizInialized/questions/QuestionWrapper.tsx';
import { isSkippableQuestionSegment } from '@/views/process/components/quizInialized/skipConfig.ts';
import { FC, useState } from 'react';

const audioUrl = 'https://lets-orange.b-cdn.net/lektor-orange-2026/ORANGE_10.mp3';
const video1Url = `${CONFIG.CDN_VIDEO_URL}/robot-inhouse-03.mp4`;
const animationUrl = 'https://lets-orange.b-cdn.net/animacje/LOQ_S3_A_01.json';

const QuestionSegment9: FC<QuestionSegmentProps> = ({ formComponent }) => {
  const isMobile = useMobileMediaQuery();
  const { t } = useTranslationWithPrefix('views.process.quizQuestions');
  const [nextSegmentVisible, setNextSegmentVisible] = useState(false);
  const [videoVisible, setVideoVisible] = useState(false);
  const handleShowVideo = () => setVideoVisible(true);
  const handleNext = () => {
    setVideoVisible(false);
    setNextSegmentVisible(true);
  };

  if (videoVisible) {
    const videoUrl = isMobile
      ? `${CONFIG.CDN_VIDEO_URL}/003%20-%20Sztab%20-%20Outro%20-%209x16.mp4`
      : `${CONFIG.CDN_VIDEO_URL}/003%20-%20Sztab%20-%20Outro.mp4`;
    return (
      <VideoFull
        fullWidth
        handleNext={handleNext}
        muted={false}
        showSkip={isSkippableQuestionSegment(9)}
        videoUrl={videoUrl}
      />
    );
  }
  return nextSegmentVisible ? (
    <QuestionWrapper animationUrl={animationUrl} defaultFormVisible formComponent={formComponent} />
  ) : (
    <QuestionWrapper
      audioUrl={audioUrl}
      onNext={handleShowVideo}
      segmentContent={
        <>
          <p className="lead fw-bold">{t('questions.9.titles.1')}</p>
          <div className="flex flex-column max-w-(--breakpoint-md) gap-s">
            <p className="lead">{t('questions.9.content.1')}</p>
            <p className="lead fw-bold">{t('questions.9.content.2')}</p>
          </div>
        </>
      }
      videoUrl={video1Url}
    />
  );
};

export default QuestionSegment9;
